import { NavLink } from "react-router-dom";
import useUser from "../../hooks/useUser/useUser";
import { useAppSelector } from "../../store/hooks";
import { useTranslation } from "../../i18n/hooks/useTranslation";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import MobileMenuStyled from "./MobileMenuStyled";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileMenu = ({ isOpen, onClose }: MobileMenuProps): JSX.Element => {
  const {
    user: { isLogged },
  } = useAppSelector((state) => state);

  const { logOutUser } = useUser();
  const { t } = useTranslation();

  const handleNavClick = () => {
    onClose();
  };

  const handleLogout = () => {
    logOutUser();
    onClose();
  };

  return (
    <MobileMenuStyled className={`mobile-menu ${isOpen ? "open" : ""}`}>
      <div className="mobile-menu__nav">
        <NavLink className="mobile-menu__item" to="/" onClick={handleNavClick}>
          {t("navigation.home")}
        </NavLink>

        <NavLink
          className="mobile-menu__item"
          to="/home"
          onClick={handleNavClick}
        >
          {t("navigation.structures")}
        </NavLink>

        {isLogged && (
          <NavLink
            className="mobile-menu__item"
            to="add-new-structure"
            onClick={handleNavClick}
          >
            {t("navigation.add")}
          </NavLink>
        )}

        <NavLink
          className="mobile-menu__item"
          to="map"
          onClick={handleNavClick}
        >
          {t("navigation.map")}
        </NavLink>

        {!isLogged ? (
          <NavLink
            className="mobile-menu__item"
            to="login"
            onClick={handleNavClick}
          >
            {t("navigation.login")}
          </NavLink>
        ) : (
          <button
            onClick={handleLogout}
            type="button"
            className="mobile-menu__item"
          >
            {t("navigation.logout")}
          </button>
        )}
      </div>

      <div className="mobile-menu__footer">
        <LanguageSelector />
      </div>
    </MobileMenuStyled>
  );
};

export default MobileMenu;
